import React from 'react';
import { Interp, css, toList } from '../../lib/render.jsx';
import { Kruis } from '../Iconen.jsx';
import Venster from '../Venster.jsx';

export default function Studio({ v }) {
  // Niet `return null` als hij weggeklapt is: dan gaat het doek uit de pagina en is
  // je werk weg. Verbergen gebeurt met studioVlakStyle. Zie logic/wip.js.
  if (!v.showStudio) return null;
  const inhoud = (
    <>
      <div style={css(v.studioVlakStyle)}>
        <div style={css(v.toolColStyle)}>
          {' '}
          <button onClick={v.selectPencil} aria-label={v.toolLabel?.pencil} aria-pressed={v.toolPressed?.pencil} onMouseEnter={v.tipEnter?.pencil} onMouseLeave={v.tipLeave} className="gp-tool" style={css(v.toolStyle?.pencil)}>
            {' '}
            <svg width={v.toolIconSize} height={v.toolIconSize} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={v.toolStroke} strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 20h9" />
              <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4Z" />
            </svg>
            {' '}
          </button>
          {' '}
          <button onClick={v.selectPen} aria-label={v.toolLabel?.pen} aria-pressed={v.toolPressed?.pen} onMouseEnter={v.tipEnter?.pen} onMouseLeave={v.tipLeave} className="gp-tool" style={css(v.toolStyle?.pen)}>
            {' '}
            {v.showLineIcon ? (<>
              {' '}
              <svg width={v.toolIconSize} height={v.toolIconSize} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={v.toolStroke} strokeLinecap="round" strokeLinejoin="round">
                <path d="M7.4 16.6 16.6 7.4" />
                <circle cx="5.4" cy="18.6" r="2.2" />
                <circle cx="18.6" cy="5.4" r="2.2" />
              </svg>
              {' '}
            </>) : null}
            {' '}
            {v.showRectIcon ? (<>
              {' '}
              <svg width={v.toolIconSize} height={v.toolIconSize} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={v.toolStroke} strokeLinecap="round" strokeLinejoin="round">
                <rect x="3.6" y="5.6" width="16.8" height="12.8" rx="1.4" />
              </svg>
              {' '}
            </>) : null}
            {' '}
            {v.showCircleIcon ? (<>
              {' '}
              <svg width={v.toolIconSize} height={v.toolIconSize} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={v.toolStroke} strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="8.4" />
              </svg>
              {' '}
            </>) : null}
            {' '}
          </button>
          {' '}
          <button onClick={v.selectSpray} aria-label={v.toolLabel?.spray} aria-pressed={v.toolPressed?.spray} onMouseEnter={v.tipEnter?.spray} onMouseLeave={v.tipLeave} className="gp-tool" style={css(v.toolStyle?.spray)}>
            {' '}
            <svg width={v.toolIconSize} height={v.toolIconSize} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={v.toolStroke} strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 4h5v5H9z" />
              <path d="M7 9h9v11H7z" />
              <path d="M18 3h.01" />
              <path d="M21 6h.01" />
              <path d="M18 9h.01" />
              <path d="M21 12h.01" />
            </svg>
            {' '}
          </button>
          {' '}
          <button onClick={v.selectFill} aria-label={v.toolLabel?.fill} aria-pressed={v.toolPressed?.fill} onMouseEnter={v.tipEnter?.fill} onMouseLeave={v.tipLeave} className="gp-tool" style={css(v.toolStyle?.fill)}>
            {' '}
            <svg width={v.toolIconSize} height={v.toolIconSize} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={v.toolStroke} strokeLinecap="round" strokeLinejoin="round">
              <path d="m19 11-8-8-8.6 8.6a2 2 0 0 0 0 2.8l5.2 5.2c.8.8 2 .8 2.8 0L19 11Z" />
              <path d="M2 13h15" />
              <path d="M22 20a2 2 0 1 1-4 0c0-1.6 1.7-2.4 2-4 .3 1.6 2 2.4 2 4Z" />
            </svg>
            {' '}
          </button>
          {' '}
          <button onClick={v.selectEraser} aria-label={v.toolLabel?.eraser} aria-pressed={v.toolPressed?.eraser} onMouseEnter={v.tipEnter?.eraser} onMouseLeave={v.tipLeave} className="gp-tool" style={css(v.toolStyle?.eraser)}>
            {' '}
            <svg width={v.toolIconSize} height={v.toolIconSize} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={v.toolStroke} strokeLinecap="round" strokeLinejoin="round">
              <path d="m7 21-4.3-4.3c-1-1-1-2.5 0-3.4l9.6-9.6c1-1 2.5-1 3.4 0l5.6 5.6c1 1 1 2.5 0 3.4L13 21" />
              <path d="M22 21H7" />
            </svg>
            {' '}
          </button>
          {' '}
          <button onClick={v.selectSelect} aria-label={v.toolLabel?.select} aria-pressed={v.toolPressed?.select} onMouseEnter={v.tipEnter?.select} onMouseLeave={v.tipLeave} className="gp-tool" style={css(v.toolStyle?.select)}>
            {' '}
            {v.showLassoIcon ? (<>
              {' '}
              <svg width={v.toolIconSize} height={v.toolIconSize} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={v.toolStroke} strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 4c4.6 0 8.4 2.3 8.4 5.2 0 2.9-3.8 5.2-8.4 5.2-1.5 0-2.9-.2-4.1-.7" />
                <path d="M7.9 13.7C5.1 12.8 3.6 11.1 3.6 9.2 3.6 6.3 7.4 4 12 4" />
                <path d="M8 14.4c.5 1.2.2 2.2-.6 2.9-.7.6-1 1.3-.7 2" />
                <circle cx="6.6" cy="20.4" r="1.6" />
              </svg>
              {' '}
            </>) : null}
            {' '}
            {v.showMarqueeIcon ? (<>
              {' '}
              <svg width={v.toolIconSize} height={v.toolIconSize} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={v.toolStroke} strokeLinecap="round" strokeLinejoin="round" strokeDasharray="3.4 2.8">
                <rect x="3.8" y="3.8" width="16.4" height="16.4" rx="1.2" />
              </svg>
              {' '}
            </>) : null}
            {' '}
          </button>
          {' '}
          <div style={{ "height": "3px", "background": "var(--ink)", "borderRadius": "2px", "flex": "0 0 auto" }} />
          {' '}
          {/* De hulplijnen onder het doek. Eigen vakje tussen twee streepjes: het is
              geen gereedschap waarmee je tekent en het verandert ook niets aan je
              tekening. Het is een laag die je aan- of uitzet. */}
          <button onClick={v.cycleHulp} aria-label={v.toolLabel?.hulp} aria-pressed={v.toolPressed?.hulp} onMouseEnter={v.tipEnter?.hulp} onMouseLeave={v.tipLeave} className="gp-tool" style={css(v.hulpStyle)}>
            {v.hulpMode === 'iso' ? (
              <svg width={v.toolIconSize} height={v.toolIconSize} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={v.toolStroke} strokeLinecap="round" strokeLinejoin="round">
                <path d="M2 8.5 12 3.5l10 5" />
                <path d="M2 15.5 12 10.5l10 5" />
                <path d="M2 8.5 12 13.5l10 -5" />
                <path d="M2 15.5 12 20.5l10 -5" />
              </svg>
            ) : (
              <svg width={v.toolIconSize} height={v.toolIconSize} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={v.toolStroke} strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 2.7 21 7.85 12 13 3 7.85Z" />
                <path d="M3 7.85v8.3L12 21.3l9-5.15v-8.3" />
                <path d="M12 13v8.3" />
              </svg>
            )}
          </button>
          {' '}
          <div style={{ "height": "3px", "background": "var(--ink)", "borderRadius": "2px", "flex": "0 0 auto" }} />
          {' '}
          <button onClick={v.incBrush} className="gp-tool" title="Dikker (+ of ])" disabled={v.noBrushInc} style={css(v.brushPlusStyle)}>
            {' '}
            <svg width={v.toolIconSize} height={v.toolIconSize} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={v.toolStroke} strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 5v14" />
              <path d="M5 12h14" />
            </svg>
            {' '}
          </button>
          {' '}
          <button onClick={v.decBrush} className="gp-tool" title="Dunner (− of [)" disabled={v.noBrushDec} style={css(v.brushMinusStyle)}>
            {' '}
            <svg width={v.toolIconSize} height={v.toolIconSize} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={v.toolStroke} strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12h14" />
            </svg>
            {' '}
          </button>
          {' '}
          <div style={{ "height": "3px", "background": "var(--ink)", "borderRadius": "2px", "flex": "0 0 auto" }} />
          {' '}
          <button onClick={v.undo} className="gp-tool" title="Ongedaan maken (Cmd/Ctrl+Z)" disabled={v.noUndo} style={css(v.undoStyle)}>
            {' '}
            <svg width={v.toolIconSize} height={v.toolIconSize} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={v.toolStroke} strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 14 4 9l5-5" />
              <path d="M4 9h11a5 5 0 0 1 0 10h-3" />
            </svg>
            {' '}
          </button>
          {' '}
          <button onClick={v.redo} className="gp-tool" title="Opnieuw (Cmd/Ctrl+Shift+Z)" disabled={v.noRedo} style={css(v.redoStyle)}>
            {' '}
            <svg width={v.toolIconSize} height={v.toolIconSize} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={v.toolStroke} strokeLinecap="round" strokeLinejoin="round">
              <path d="m15 14 5-5-5-5" />
              <path d="M20 9H9a5 5 0 0 0 0 10h3" />
            </svg>
            {' '}
          </button>
          {' '}
        </div>
        <div style={{ "position": "relative", "flex": "1 1 auto", "display": "flex", "flexDirection": "column", "alignItems": "center", "justifyContent": "flex-start", "gap": "24px", "overflow": "auto", "padding": "64px 24px 28px", "minWidth": "0" }}>
          {/* De strook met het thema en een verzoekje hangt onder het doek, niet erboven:
              zo houdt het tekenvlak de ruimte en valt de kop niet vol.

              34 en niet 10: met tien pixels stond hij 59 boven en 10 onder, dus tegen
              de taakbalk aangeplakt. De ruimte tussen de beeldenrij en de balk is
              altijd ongeveer even groot, want het doek rekt zich uit tot wat er over
              is, dus één getal is hier genoeg om hem in het midden te houden. */}
          <div style={{ "position": "absolute", "bottom": "34px", "left": "24px", "right": "24px", "zIndex": "3", "display": "flex", "flexDirection": "column", "alignItems": "center", "gap": "8px" }}>
            {v.hasActiveRequest ? (<>
              <div style={{ "display": "flex", "alignItems": "center", "gap": "10px", "border": "3px solid var(--ink)", "borderRadius": "12px", "background": "var(--geel-vlak)", "boxShadow": "3px 3px 0 var(--ink)", "padding": "8px 9px 8px 12px", "flex": "0 0 auto", "maxWidth": "100%" }}>
                <div style={{ "fontSize": "13px", "fontWeight": "700", "lineHeight": "1.4", "minWidth": "0" }}>
                  <Interp v={v.activeRequestText} />
                </div>
                <button onClick={v.clearActiveRequest} title="Verzoekje loslaten" style={{ "border": "none", "background": "transparent", "cursor": "pointer", "color": "var(--ink)", "display": "flex", "padding": "4px", "flex": "0 0 auto" }}>
                  <Kruis maat={16} />
                </button>
              </div>
            </>) : null}
            {v.duoActive ? (<>
              <div style={{ "display": "flex", "alignItems": "center", "gap": "10px", "border": "3px solid var(--ink)", "borderRadius": "12px", "background": "var(--lila)", "boxShadow": "3px 3px 0 var(--ink)", "padding": "8px 12px 8px 9px", "flex": "0 0 auto", "maxWidth": "100%" }}>
                <img alt="" src={v.duoPartnerAvatar} style={{ "width": "30px", "height": "30px", "imageRendering": "pixelated", "border": "3px solid var(--ink)", "borderRadius": "8px", "background": "#fff", "display": "block", "flex": "0 0 auto" }} />
                <div style={{ "fontSize": "13px", "fontWeight": "700", "lineHeight": "1.4" }}>
                  <Interp v={v.duoBannerText} />
                </div>
              </div>
            </>) : null}
            {v.hasTheme ? (<>
              <div style={{ "display": "flex", "alignItems": "center", "gap": "9px", "border": "3px solid var(--ink)", "borderRadius": "12px", "background": "var(--geel-vlak)", "boxShadow": "3px 3px 0 var(--ink)", "padding": "7px 8px 7px 12px", "flex": "0 0 auto", "maxWidth": "100%" }}>
                <div onClick={v.openTheme} title="Thema van vandaag" style={{ "display": "flex", "alignItems": "center", "gap": "9px", "cursor": "pointer", "minWidth": "0" }}>
                  <span style={{ "fontSize": "15px" }}>
                    🎨
                  </span>
                  <div style={{ "fontSize": "13px", "fontWeight": "700", "lineHeight": "1.4" }}>
                    {"Thema van vandaag: "}
                    <Interp v={v.themeWord} />
                  </div>
                </div>
                <button onClick={v.hideTheme} title="Thema verbergen" style={{ "border": "none", "background": "transparent", "cursor": "pointer", "color": "var(--ink)", "display": "flex", "padding": "4px", "flex": "0 0 auto" }}>
                  <Kruis maat={15} />
                </button>
              </div>
            </>) : null}
          </div>
          <div style={css(v.canvasBoxStyle)}>
            {' '}
            {/* Onder de tekening, niet erover: dit staat vóór het doek in de boom en
                het doek is doorzichtig waar je nog niets gezet hebt. Zet je er een
                pixel, dan is de hulplijn daar weg. */}
            {v.hulpAan ? (
              <svg style={css(v.hulpSvgStyle)} viewBox={v.hulpViewBox} preserveAspectRatio="none" shapeRendering="crispEdges" aria-hidden="true">
                <path d={v.hulpVlak} fill={v.hulpKleur} fillOpacity={v.hulpDek} stroke="none" />
              </svg>
            ) : null}
            {' '}
            {v.showOnion ? (<>
              {' '}
              <img src={v.onionSrc} alt="" style={{ "position": "absolute", "inset": "0", "width": "100%", "height": "100%", "imageRendering": "pixelated", "opacity": ".22", "pointerEvents": "none", "display": "block" }} />
              {' '}
            </>) : null}
            {' '}
            <canvas ref={v.canvasRef} width={v.gridW} height={v.gridH} onMouseDown={v.onMouseDown} onMouseMove={v.onMouseMove} onMouseUp={v.onMouseUp} onContextMenu={v.onCanvasContext} onDoubleClick={v.onCanvasDblClick} onMouseLeave={v.onCanvasLeave} style={{ "position": "relative", "width": "100%", "height": "100%", "imageRendering": "pixelated", "cursor": "crosshair", "background": "transparent", "display": "block" }} />
            {' '}
            <div ref={v.hoverRef} style={{ "position": "absolute", "pointerEvents": "none", "boxSizing": "border-box", "display": "none", "background": "rgba(124,92,255,.22)", "border": "1px solid rgba(124,92,255,.85)" }} />
            {' '}
            {v.showSel ? (<>
              {' '}
              <svg style={css(v.selSvgStyle)} viewBox={v.selViewBox} preserveAspectRatio="none">
                {' '}
                <path d={v.selFillD} fill="rgba(124,92,255,.18)" stroke="none" />
                {' '}
                <path d={v.selPathD} fill="none" stroke="var(--paars)" strokeWidth="0.22" strokeLinecap="square" strokeDasharray="0.5,0.5" style={{ "animation": "marchingAnts .5s linear infinite" }} />
                {' '}
              </svg>
              {' '}
            </>) : null}
            {' '}
            {v.playing ? (<>
              {' '}
              <div onClick={v.stopPlay} title="Klik om te stoppen" style={{ "position": "absolute", "inset": "0", "zIndex": "6", "background": "#fff", "cursor": "pointer" }}>
                {' '}
                <img ref={v.playRef} alt="" style={{ "position": "absolute", "inset": "0", "width": "100%", "height": "100%", "imageRendering": "pixelated", "background": "#fff", "display": "block" }} />
                {' '}
              </div>
              {' '}
            </>) : null}
            {' '}
          </div>
          {v.showFrameStrip ? (<>
            <div style={css(v.frameStripStyle)}>
              {' '}
              {v.showPlay ? (<>
                {' '}
                <button onClick={v.togglePlay} className="gp-btn" disabled={v.playOff} title={v.playTitle} style={css(v.playBtnStyle)}>
                  {' '}
                  {v.playing ? (<>
                    {' '}
                    <svg width="19" height="19" viewBox="0 0 24 24" fill="currentColor" stroke="none">
                      <rect x="6" y="5.5" width="4.4" height="13" rx="1.2" />
                      <rect x="13.6" y="5.5" width="4.4" height="13" rx="1.2" />
                    </svg>
                    {' '}
                  </>) : null}
                  {' '}
                  {v.notPlaying ? (<>
                    {' '}
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" stroke="none">
                      <path d="M8 5.4a1 1 0 0 1 1.5-.87l8.2 6.6a1 1 0 0 1 0 1.74l-8.2 6.6A1 1 0 0 1 8 18.6V5.4Z" />
                    </svg>
                    {' '}
                  </>) : null}
                  {' '}
                </button>
                {' '}
              </>) : null}
              {' '}
              {toList(v.frameTiles).map((f, $index) => (
                <React.Fragment key={$index}>
                  {' '}
                  <button onClick={f?.onClick} draggable={f?.draggable} onDragStart={f?.onDragStart} onDragOver={f?.onDragOver} onDragLeave={f?.onDragLeave} onDrop={f?.onDrop} onDragEnd={f?.onDragEnd} className="gp-btn" title={f?.title} style={css(f?.style)}>
                    {' '}
                    <img src={f?.src} alt="" style={css(f?.imgStyle)} />
                    {' '}
                  </button>
                  {' '}
                </React.Fragment>
              ))}
              {' '}
            </div>
          </>) : null}
        </div>
        <div style={{ "flex": "0 0 152px", "background": "#fff", "borderLeft": "4px solid var(--ink)", "display": "flex", "flexDirection": "column", "padding": "12px 12px", "gap": "12px", "overflowY": "auto" }}>
          <div style={{ "display": "grid", "gridTemplateColumns": "repeat(2, 1fr)", "gap": "8px" }}>
            {toList(v.palette).map((sw, $index) => (
              <React.Fragment key={$index}>
                <div onClick={sw?.onClick} className="gp-swatch" title={sw?.title} style={css(sw?.style)} />
              </React.Fragment>
            ))}
          </div>
          <div style={{ "marginTop": "auto", "display": "flex", "flexDirection": "column", "gap": "8px" }}>
            <button onClick={v.onNew} className="gp-btn" style={{ "width": "100%", "justifyContent": "center", "fontSize": "15px", "padding": "13px" }}>
              Nieuw
            </button>
            {v.duoIdle ? (<>
              <button onClick={v.openDuoPick} className="gp-btn" style={{ "width": "100%", "justifyContent": "center", "gap": "7px", "fontSize": "15px", "padding": "13px", "background": "var(--paars)", "color": "#fff" }}>
                {' '}
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.9" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                  <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
                {"\n            Samen\n          "}
              </button>
            </>) : null}
            {v.duoActive ? (<>
              <button onClick={v.endDuo} className="gp-btn" style={{ "width": "100%", "justifyContent": "center", "fontSize": "14px", "padding": "11px" }}>
                Stop samen
              </button>
            </>) : null}
            <button onClick={v.onPublish} className="gp-btn pink" style={css(v.hoofdKnopStyle)}>
              {"\n          Plakken!\n        "}
            </button>
          </div>
        </div>
      </div>
    </>
  );

  // Op de telefoon vult het tekenscherm het beeld, precies zoals het was.
  if (v.studioMobiel) return inhoud;

  /**
   * Op een computer vult hij het scherm boven de taakbalk, met bovenin een titelbalk:
   * een streepje om hem weg te klappen en een kruisje om hem te sluiten. Kader en
   * balk komen uit de vensterlaag; zie logic/venster.js en studioVenster.
   */
  return (
    <Venster
      v={v} venster={v.studioVenster} titel={v.studioTitel} onSluit={v.sluitStudio}
    >
        {inhoud}
    </Venster>
  );
}
